import React from "react";

import RobotNavigation from "../features/robot/RobotNavigation";
import RobotHealth from "../features/robot/RobotHealth";
import RobotSummary from "../features/robot/RobotSummary";

function HealthPage(props) {
  const { isCustomer } = props;
  return (
    <>
      <RobotNavigation {...props} />
      {isCustomer ? <RobotSummary {...props} /> : <RobotHealth {...props} />}
    </>
  );
}

export default HealthPage;
